import { render, staticRenderFns } from "./CoreItemOne.vue?vue&type=template&id=41d45da6&scoped=true"
import script from "./CoreItemOne.vue?vue&type=script&lang=js"
export * from "./CoreItemOne.vue?vue&type=script&lang=js"
import style0 from "./CoreItemOne.vue?vue&type=style&index=0&id=41d45da6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d45da6",
  null
  
)

export default component.exports